/**
 * The component kit (WP0): the icon, avatars and presence come from
 * @neosocial/ui, one source for the app and the Console
 * (docs/design/visual-overhaul.md §7.3, §7.8, §10); the app's Avatar adds its
 * image-URL config. The controls (buttons, icon buttons, segmented control,
 * switch, spinner, Ltr) live in ./controls.tsx (WP3) and are re-exported
 * here, so imports stay as they are.
 */
import type { PresenceStatus, User } from '@neosocial/protocol';
import { Avatar as KitAvatar } from '@neosocial/ui/avatar';
import { memo } from 'react';
import { assetUrl } from '../lib/config';

export { Icon, ICON_PX, ICON_STROKE, type IconSize } from '@neosocial/ui/icon';
export type { IconName } from './icons';
export {
  PALETTE,
  Presence,
  avatarStyle,
  gradStyle,
  initials,
  initialsScript,
  paletteIndex,
  presenceDot,
} from '@neosocial/ui/avatar';

export interface AvatarProps {
  user: Pick<User, 'id' | 'username' | 'global_name' | 'avatar'> | null | undefined;
  /** Shown name (nickname); defaults to the display name. */
  name?: string;
  size: number;
  presence?: PresenceStatus | null;
  speaking?: boolean;
  cls?: string;
  label?: string;
}

export const Avatar = memo(function Avatar({
  user,
  name,
  size,
  presence,
  speaking,
  cls,
  label,
}: AvatarProps) {
  return (
    <KitAvatar
      id={user?.id ?? '0'}
      name={name ?? user?.global_name ?? user?.username ?? '?'}
      size={size}
      src={assetUrl(user?.avatar ?? null)}
      presence={presence}
      speaking={speaking}
      cls={cls}
      label={label}
    />
  );
});

export {
  Btn,
  EmptyState,
  IconBtn,
  Ltr,
  Range,
  Seg,
  Select,
  Skeleton,
  Spinner,
  Switch,
  rangeFill,
  type SegOption,
} from './controls';
